import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CATEGORIES from 'constants/categories';
import { useQueryPublicCourses } from 'gql/queries/course';
import { useQueryTags } from 'gql/queries/tag';

import QuestionImportPublicCourses from './QuestionImportPublicCourses';

const QuestionImportPublicCoursesContainer = (props) => {
  const { t } = useTranslation();
  const { data: tagsData } = useQueryTags();
  const tags = tagsData ? tagsData.tags.map((tag) => tag.title) : [];
  const { isLoading, data } = useQueryPublicCourses();
  const courses = isLoading ? [] : data.publicCourses;
  const handleResetFilters = useCallback((setFieldValue) => {
    setFieldValue('category', '');
    setFieldValue('language', '');
    setFieldValue('destination', '');
    setFieldValue('tags', []);
  }, []);
  const [showFilters, setShowFilters] = useState(false);
  const toggleFilters = useCallback(() => {
    setShowFilters(!showFilters);
  }, [setShowFilters, showFilters]);
  const orderedCategories = CATEGORIES.map((category) => ({
    key: category.key,
    translation: t(category.translation),
  })).sort((a, b) =>
    a.key === 'other' ? 1 : a.translation.localeCompare(b.translation),
  );
  return (
    <QuestionImportPublicCourses
      courses={courses}
      handleResetFilters={handleResetFilters}
      isLoading={isLoading}
      orderedCategories={orderedCategories}
      showFilters={showFilters}
      t={t}
      tags={tags}
      toggleFilters={toggleFilters}
      {...props}
    />
  );
};

export default QuestionImportPublicCoursesContainer;
